import { render, staticRenderFns } from "./ListSanctionedCountries.vue?vue&type=template&id=647d2214&scoped=true&"
import script from "./ListSanctionedCountries.vue?vue&type=script&lang=js&"
export * from "./ListSanctionedCountries.vue?vue&type=script&lang=js&"
import style0 from "./ListSanctionedCountries.vue?vue&type=style&index=0&id=647d2214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647d2214",
  null
  
)

export default component.exports